module.exports = __webpack_public_path__ + "img/cap_05.722e8288.jpg";